<template>
  <div
    class="supplier-offers">
    <v-data-table
      calculate-widths
      class="supplier-offers-table"
      disable-pagination
      fixed-header
      :headers="headers"
      hide-default-footer
      item-key="index"
      :items="items"
      :no-data-text="$t('Tenders.NoData')">
      <template #[`item.tenderNumber`]="{ item }">
        <router-link
          class="bold"
          data-qa="tenderNumber"
          :to="{name: 'tenderitem', params: { id: item.tenderId, org: $route.params.org}}">
          {{ item.tenderNumber }}
        </router-link>
      </template>
      <template #[`item.biddingPeriodEnd`]="{ item }">
        <div data-qa="biddingPeriodEnd">
          {{ formatDate(item.biddingPeriodEnd) }}
        </div>
      </template>
      <template #[`item.lotName`]="{ item }">
        <div data-qa="lotName">
          {{ item.lotName }}
        </div>
      </template>
      <template #[`item.quantity`]="{ item }">
        <div data-qa="quantity">
          {{ item.quantity }}
          <span v-if="item.price && item.measuringUnit && item.measuringUnit.title">{{ item.measuringUnit.title }}</span>
        </div>
      </template>
      <template #[`item.price`]="{ item }">
        <div data-qa="price">
          {{ formSum( item.price ) }}
          <span v-if="item.price">{{ $t('Tenders.hrn') }}</span>
        </div>
      </template>
      <template #[`item.sum`]="{ item }">
        <div data-qa="sum">
          {{ formSum( item.sum ) }}
          <span v-if="item.sum">{{ $t('Tenders.hrn') }}</span>
        </div>
      </template>
      <template #[`item.winner`]="{ item }">
        <sIcon
          v-if="item.isWinner"
          data-qa="isWinner"
          type="accept"/>
      </template>
    </v-data-table>
    <InfinityUpdater
      :action="infinityLoad"
      :active="infinity_load"
      call-on-mount
      :loading="loading"
      selector="#components-layout-supplier-item #content-container"/>
  </div>
</template>

<script>
import InfinityUpdater from 'components/extends/InfinityUpdater.vue'

import { modalMixin } from 'mixins'

export default {
  name: 'supplierOffers',
  mixins: [modalMixin],
  data() {
    return {
      items: [],
      infinity_load: true,
      statuses: [],
      loading: false
    }
  },
  computed: {
    headers() {
      return [
        {text: this.$t('Suppliers.TenderNumber'), value: 'tenderNumber', width: '15%' },
        {text: this.$t('Tenders.EndDate'), value: 'biddingPeriodEnd', width: '15%' },
        {text: this.$t('Tenders.LotNomination'), value: 'lotName', width: '25%' },
        {text: this.$t('Catalog.Amount'), value: 'quantity', width: '10%' },
        {text: this.$t('Catalog.Price'), value: 'price', width: '12%' },
        {text: this.$t('Suppliers.Summ'), value: 'sum', width: '13%' },
        {text: this.$t('Tenders.Winner'), value: 'winner', width: '10%', sortable: false },
      ]
    },
    per_page() {
      const visible = this.$root.$el.clientHeight - 200
      return Math.round(visible / 50 )
    },
  },
  methods: {
    async infinityLoad() {
      this.loading = true
      let items = await this.$store.dispatch('getSupplierBids', {supplierOrgId: +this.$route.params.id , take: this.per_page, skip: this.items.length }) || []
      if ( items?.length < this.per_page ) {
        this.infinity_load = false
      }
      if ( items?.length ) {
        this.items.push(...items)
      }
      this.loading = false
    }
  },
  components: {
    InfinityUpdater
  }
}
</script>
